// extracted by mini-css-extract-plugin
export var productImage = "_lu-1";
export var viewLink = "_lu-2";
export var wishlistItem = "_lu-0";